import styled from 'styled-components'
import Checkbox from '@material-ui/core/Checkbox'
import MaterialCloseIcon from '@material-ui/icons/Close'
import { Edit, Delete, Save, Cancel } from '@material-ui/icons'
import MaterialKeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

import { Colors } from '~/styles'
import { Button } from '@material-ui/core'

const Container = styled.div`
  padding: 10px 20px;
  background: transparent;
`

const TopFormWrapper = styled.div`
  width: 100%;
  display: grid;
  column-gap: 10px;
  grid-template-columns: repeat(3, 1fr);
`

const DurationInputContainer = styled.div`
  margin-top: -3px;
`

const DurationLabel = styled.label`
  font-size: 11px;
  margin: 7px 0 0 10px;
  transform-origin: top left;
  color: rgba(0, 0, 0, 0.54);
  transform: translate(0, 1.5px) scale(0.75);
`

const DurationInputWrapper = styled.div`
  display: grid;
  column-gap: 5px;
  grid-template-columns: repeat(2, 1fr);
`

const GridContainer = styled.div`
  height: 450px;
  overflow: auto;
  margin-top: 10px;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.borderGrey};
`

const HeaderRowGrid = styled.tr`
  & {
    color: white;
    text-align: left;
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: ${Colors.softBlue};
  }
`

const Grid = styled.table`
  width: 100%;
  overflow-y: auto;
  table-layout: auto;
  border-collapse: collapse;

  th,
  td {
    padding: 8px;
    cursor: default;
    border: 1px solid #ddd;
  }

  & .equipment-icon {
    cursor: pointer;
  }
`

const EmptyListCell = styled.div`
  text-align: center;
  color: ${Colors.grey};
`

const BodyRowGrid = styled.tr``

const BodyRowGridDetail = styled.tr`
  background: ${Colors.borderGrey};
`

const ActivityCellWrapper = styled.td`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 0px !important;
  border-right: 0px !important;
`

const GreenCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    color: green;
  }

  &.MuiCheckbox-root.Mui-checked {
    color: green;
  }
`

const KeyboardArrowDownIcon = styled(MaterialKeyboardArrowDownIcon)`
  cursor: pointer;
  margin-right: 10px;
  color: ${Colors.grey};
  transform: ${(p) => (p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`

const InnerGrid = styled.table`
  width: 100%;
`

const InnerGridHeader = styled.tr`
  background: #ddd;
  color: ${Colors.black};
`

const InnerGridRow = styled.tr``

const DeleteIcon = styled(Delete)`
  cursor: ${(p) => (p.disable ? 'not-allowed' : 'pointer')};
  color: ${(p) => (p.disable ? Colors.softGrey : Colors.softRed)};
`

const InnerGridActionCell = styled.td`
  height: 75px;
  display: flex;
  align-items: center;
  cursor: grab !important;
  justify-content: space-evenly;
`

const ActionIconWrapper = styled.div`
  gap: 4px;
  display: flex;
  cursor: ${(p) => (p.disable ? 'not-allowed' : 'pointer')};
`

const AddTaskCell = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
`

const AddTaskInput = styled.input`
  height: 30px;
  padding: 5px 10px;
  background: ${Colors.white};
  border: 1px solid ${Colors.borderGrey};
`

const AddTaskButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const AddTaskModalContainer = styled.div`
  width: 100%;
  height: 43rem;
  padding: 20px;
`

const AddTaskModalTop = styled.div`
  display: flex;
  justify-content: space-between;
`

const AddTaskModalTopTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
`

const CloseIcon = styled(MaterialCloseIcon)`
  cursor: pointer;

  &.MuiSvgIcon-root {
    font-size: 1.75rem;
  }
`

const AddTaskGridContainer = styled.div`
  margin-top: 15px;
`

const ButtonAddTaskContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const AddItemWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  color: ${Colors.softBlue};
`

const CircularProgressWrapper = styled.div`
  width: 100%;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const EditIcon = styled(Edit)`
  cursor: ${(p) => (p.disable ? 'not-allowed' : 'pointer')};
  color: ${(p) => (p.disable ? Colors.softGrey : Colors.softGreen)};
`

const SaveIcon = styled(Save)`
  cursor: pointer;
  color: ${Colors.softBlue};
`

const CancelIcon = styled(Cancel)`
  cursor: pointer;
  color: ${Colors.red};
`

const ActionCell = styled.td`
  min-height: 75px;
  width: 200px;
`

const ActionCellWrapper = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ActionCellContainer = styled.div`
  height: 82px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: ${(p) => p.justifyContent || 'center'};
`

const DetailGridCell = styled.td`
  padding: 0 !important;
`

const RegularGridCell = styled.td`
  padding: 8px;
`

const THead = styled.thead`
  top: 0;
  z-index: 99;
  position: sticky;
`

const ButtonSort = styled.button`
  min-width: 80px;
  color: #333333;
  border-radius: 32px;
  background-color: #ffff;
  border: 1px solid lightblue;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const ModalSort = styled.div`
  position: absolute;
  width: 300px;
  min-height: 100px;
  right: 0;
  background-color: white;
  margin-top: 10px;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid aliceblue;
  z-index: 1;
`

const SortListWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 5px;
  color: #4a576f;
  align-items: center;
`

const SortTextList = styled.div`
  border: 2px solid #dee0e5;
  width: 200px;
  padding: 5px;
  border-radius: 5px;
  margin-right: 5px;
  font-weight: 400;
`

const ButtonClose = styled.button`
  min-width: 80px;
  color: #a3aab6;
  border-radius: 5px;
  background-color: #0013340a;
  border: 1px solid lightblue;
  height: 30px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
`

const ButtonFilter = styled.button`
  min-width: 80px;
  color: #ffff;
  border-radius: 5px;
  background-color: #0a81ad;
  border: 1px solid lightblue;
  height: 30px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-left: 3px;
`

const StatusCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const ModalTaskChecklistContainer = styled.div`
  width: 700px;
  height: max-content;
`

const ModalTaskChecklistHeaderContainer = styled.div`
  display: flex;
  padding: 16px 24px;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.softBlue};
`

const TaskChecklistHeaderTitle = styled.div`
  color: ${Colors.white};
  font-size: 20px;
  font-weight: 600;
`

const ModalTaskChecklistFormContainer = styled.div`
  padding: '16px 24px';
  background-color: ${Colors.white};
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ModalTaskAttachmentContainer = styled.div`
  width: 1200px;
  height: max-content;
`

export const DocumentUploadButtonContainer = styled.div`
  width: 100%;
  height: 180px;
  display: flex;
  margin: 24px auto 24px auto;
  /* padding: 20px auto;
  align-items: center;
  justify-content: center; */
  background-color: #f8f8f8;
  border: 1px dashed #707070;
`

export const UploadButton = styled.label`
  padding: 8px 16px;
  border-radius: 4px;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
  color: black;
  justify-content: center;
  border: 1px solid #707070;
  background: #eaeaea;
`
export const PointerCell = styled.div`
  cursor: pointer;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`
export const IconWrapper = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
`
export const ExclamationIcon = styled.img`
  width: 16px;
  height: 16px;
`

export const ErrorLabel = styled.span`
  font-size: 10px;
  color: ${Colors.softRed};
`
export const TallySheetButton = styled(Button)`
  font-size: 9px;
  font-weight: 600;
  padding: 6px 8px;
  border-radius: 32px;
  text-transform: none;
  color: ${({ disabled }) => (disabled ? Colors.grayDisable : Colors.softBlue)};
  background-color: ${Colors.white};
  border: ${({ disabled }) =>
    disabled
      ? ` 1px solid ${Colors.grayDisable}`
      : ` 1px solid ${Colors.softBlue}`};
`

export default {
  Grid,
  THead,
  EditIcon,
  SaveIcon,
  Container,
  InnerGrid,
  CloseIcon,
  ErrorLabel,
  ModalSort,
  DeleteIcon,
  ButtonSort,
  CancelIcon,
  ActionCell,
  ButtonClose,
  BodyRowGrid,
  AddTaskCell,
  PointerCell,
  IconWrapper,
  AddTaskInput,
  SortTextList,
  InnerGridRow,
  ButtonFilter,
  UploadButton,
  GridContainer,
  DurationLabel,
  HeaderRowGrid,
  GreenCheckbox,
  EmptyListCell,
  DetailGridCell,
  TopFormWrapper,
  AddItemWrapper,
  SortListWrapper,
  InnerGridHeader,
  AddTaskModalTop,
  RegularGridCell,
  ExclamationIcon,
  LoadingContainer,
  BodyRowGridDetail,
  ActionIconWrapper,
  ActionCellWrapper,
  ActionCellContainer,
  InnerGridActionCell,
  ActivityCellWrapper,
  AddTaskGridContainer,
  AddTaskModalTopTitle,
  AddTaskButtonWrapper,
  DurationInputWrapper,
  AddTaskModalContainer,
  KeyboardArrowDownIcon,
  StatusCheckboxWrapper,
  ButtonAddTaskContainer,
  DurationInputContainer,
  CircularProgressWrapper,
  TaskChecklistHeaderTitle,
  ModalTaskChecklistContainer,
  ModalTaskAttachmentContainer,
  DocumentUploadButtonContainer,
  ModalTaskChecklistFormContainer,
  ModalTaskChecklistHeaderContainer
}
